import { ICaremapAccess } from '../caremap/ICareMap';

// The user-facing name of each access level.
export const accessLabels: { [access in ICaremapAccess]: 'Co-Owner' | 'Viewer' | 'Contributor' } = {
    'co-owner': 'Co-Owner',
    'view-only': 'Viewer',
    contributor: 'Contributor'
};

// Tracking events and property values keyed by access level.
export const accessRemovedEvents: { [access in ICaremapAccess]: string } = {
    'co-owner': 'Co-Owner Removed',
    'view-only': 'Permanent Viewer Removed',
    contributor: 'Contributor Removed'
};

export const invitationCancelledTypes: { [access in ICaremapAccess]: string } = {
    'co-owner': 'co-owner',
    'view-only': 'permanent viewer',
    contributor: 'contributor'
};

export const inviteAcceptedEvents: { [access in ICaremapAccess]: string } = {
    'co-owner': 'Co-Owner Invite Accepted',
    'view-only': 'Permanent Viewer Invite Accepted',
    contributor: 'Contributor Invite Accepted'
};
